"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Provider.css"));
var _ProviderLogo = require("../ProviderLogo");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Provider = props => {
  const {
    providers
  } = props;
  const author = React.useMemo(() => {
    return providers ? providers[0] : null;
  }, [providers]);
  const bank = React.useMemo(() => {
    return providers ? providers[1] : null;
  }, [providers]);
  if (!author) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['provider']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['provider-logo'], bank && style['logo-with-bank'])
  }, /*#__PURE__*/React.createElement(_ProviderLogo.ProviderLogo, {
    logo: author?.logo,
    type: "builder"
  }), bank && /*#__PURE__*/React.createElement(_ProviderLogo.ProviderLogo, {
    logo: bank.logo,
    type: "bank"
  })), /*#__PURE__*/React.createElement("div", {
    className: style['provider-names']
  }, /*#__PURE__*/React.createElement("span", {
    className: style['provider-name']
  }, author.name), bank && /*#__PURE__*/React.createElement("span", {
    className: style['bank-name']
  }, " \u30FB ", bank.name)));
};
exports.Provider = Provider;